'use strict';

angular.module('basketModule', [
    'ngKomondorMediaLibrary',
    'ngKomondorResourceView'
]);